import { combineEpics } from 'redux-observable';
import settingsEpic from './settingsEpic';

export default combineEpics(settingsEpic);
